import React from "react";
import { toast } from "react-toastify";
import correctImg from "../Assets/images/correct_green.svg";
import errorImg from "../Assets/images/new_error.svg";

/* ---------- DEVICE UTILS ---------- */

export const isMobile = () => {
  if (typeof window === "undefined") return false;
  return window.innerWidth < 768;
};

export const agentCode = localStorage.getItem("agentCode");

/* ---------- TOAST MESSAGE ---------- */

const Msg = ({ heading, message, icon }) => (
  <div className="toastMainWrap">
    <img src={icon || correctImg} alt="" />
    <p>
      {heading && <span>{heading}</span>} {message}
    </p>
  </div>
);

export const toaster = (type, msg, heading) => {
  const text = msg || "Something went wrong !";

  switch (type) {
    case "success":
      toast.success(<Msg message={text} heading={heading} />);
      break;
    case "error":
      toast.error(<Msg message={text} heading={heading} icon={errorImg} />);
      break;
    case "warn":
      toast.warn(<Msg message={text} heading={heading} />);
      break;
    case "info":
    default:
      toast.info(<Msg message={text} heading={heading} />);
  }
};

/* ---------- DATE UTILS ---------- */

export const formateDate = (dv) => {
  if (!dv) return null;

  const dd = String(dv.getDate()).padStart(2, "0");
  const mm = String(dv.getMonth() + 1).padStart(2, "0");
  const yyyy = dv.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};

export const formateDateAndTime = (dv) => {
  if (!dv) return null;

  const [datePart, timePart] = dv.split(" ");
  const date = datePart.split("-");

  return `${date[1]}/${date[0]}/${date[2]} ${timePart}`;
};

export const formateDateFormat = (dv) => {
  if (!dv) return null;

  const date = dv.split("-");
  return `${date[1]}/${date[0]}/${date[2]}`;
};

/* ---------- NUMBER TO WORDS ---------- */

export const convertNumberToWords = (amount) => {
  if (!amount) return "";

  const words = [];
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";

  const number = amount.toString().split(".")[0].replace(/,/g, "");
  const nLength = number.length;
  let wordsString = "";

  if (nLength <= 9) {
    const nArray = new Array(9).fill(0);
    const received = number.split("");

    for (let i = 9 - nLength, j = 0; i < 9; i += 1, j += 1) {
      nArray[i] = parseInt(received[j], 10);
    }

    for (let i = 0; i < 9; i += 1) {
      if ([0, 2, 4, 7].includes(i) && nArray[i] === 1) {
        nArray[i + 1] += 10;
        nArray[i] = 0;
      }
    }

    for (let i = 0; i < 9; i += 1) {
      const value = [0, 2, 4, 7].includes(i) ? nArray[i] * 10 : nArray[i];

      if (value !== 0) wordsString += `${words[value]} `;

      if (
        (i === 1 && value !== 0) ||
        (i === 0 && value !== 0 && nArray[i + 1] === 0)
      ) {
        wordsString += "Crores ";
      }

      if (
        (i === 3 && value !== 0) ||
        (i === 2 && value !== 0 && nArray[i + 1] === 0)
      ) {
        wordsString += "Lakhs ";
      }

      if (
        (i === 5 && value !== 0) ||
        (i === 4 && value !== 0 && nArray[i + 1] === 0)
      ) {
        wordsString += "Thousand ";
      }

      if (i === 6 && value !== 0) {
        wordsString +=
          nArray[i + 1] !== 0 && nArray[i + 2] !== 0
            ? "Hundred and "
            : "Hundred ";
      }
    }

    wordsString = `Rupees ${wordsString}`.replace(/\s+/g, " ").trim();
  }

  return wordsString;
};

/* ---------- OTHER UTILS ---------- */

export const isDateValid = (date) => {
  const d = new Date(date);
  return d.toString() !== "Invalid Date";
};

export const copyLinkToClipboard = (link) => {
  const input = document.createElement("input");
  input.value = link;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  toaster("success", "Link Copied!");
};

export const isNativeApp = () => {
  const { userAgent, standalone } = window.navigator;
  const ua = userAgent.toLowerCase();
  const isIOS = /iphone|ipod|ipad/.test(ua);
  const isSafari = /safari/.test(ua);

  if (isIOS) {
    return !standalone && !isSafari;
  }

  return ua.includes("wv");
};

/* ---------- TEXT UTILS ---------- */

export const addEllipsisToText = (fullText) => {
  if (!fullText || typeof fullText !== "string") return "";

  const words = fullText.split(" ");
  return words.length > 10
    ? `${words.slice(0, 10).join(" ")}...`
    : fullText;
};

export const formatJourneyStatusLabel = (statusValue) => {
  if (!statusValue) return "";

  const label = statusValue?.split("_").join(" ").toLowerCase();

  return label === "underwriting" ? "in review" : label;
};
